<div class="card border-primary ui-g" style="display: block; padding: .5em;">
    <!-- <div class="ui-g-12"> -->
    <div class="ui-g ui-fluid">


        <p-table class="ui-g-12" [value]="listCursoDisp" [(selection)]="selCursoDisp" dataKey="codCurso"
            selectionMode="single" [responsive]="true" autoLayout="true" [paginator]="true" [rows]="7" [lazy]="true"
            (onRowSelect)="onRowSelect($event)">
            <!-- (onLazyLoad)="onPage($event)" 
                [totalRecords]="listCount"
        -->

            <!-- <p-table class="ui-g-12" [value]="listCursoDisp" [(selection)]="selCursoDisp" selectionMode="single"
            [responsive]="true" autoLayout="true" [paginator]="true" [rows]="7"> -->

            <ng-template pTemplate="caption">
                Cursos inscritos pendientes
            </ng-template>

            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th style="width:40%">Tema</th>
                    <th style="width:20%">Fecha de Programación</th>
                    <th style="width:20%">Hora fin</th>
                    <th style="width:20%">Estado</th>


                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-CursoInscrito>
                <tr [pSelectableRow]="CursoInscrito">
                    <td><span class="ui-column-title">Tema</span>{{CursoInscrito.tema}}</td>
                    <td><span class="ui-column-title">Fecha de Programación</span>{{formatoFecha(CursoInscrito.fechIni)}}</td>
                    <td><span class="ui-column-title">Hora fin</span>{{CursoInscrito.horaFin}}</td>
                    <td><span class="ui-column-title">Estado</span>{{getEstado(CursoInscrito.estadoCurso)}}</td>
                </tr>
            </ng-template>
        </p-table>


<!-- <div class="ui-g-6 ui-md-6">
    <button type="button" pButton (click)="AbrirPdf()" label="pdf" class="ui-button-success"
    style="width: 100%;"></button>
</div>

<div class="ui-g-6 ui-md-6">
    <button type="button" pButton (click)="AbrirVideo()" label="video" class="ui-button-success"
    style="width: 100%;"></button>
</div> -->

    </div>
</div>





